import { HisSearchResultRow } from 'hisng';
import { AbstractDetailViewListEntry, SimpleLinkDefinition, RowLabels } from './abstract-detail-view-list-entry';
import { DetailViewListUtils } from './detail-view-list-utils';


export class PatentDetailViewListEntry extends AbstractDetailViewListEntry {

    rowLabels: RowLabels = {
        priorityPatent: 'fs.res.patent.Patent.priorityPatent',
        status: 'fs.res.patent.Patent.status',
        title: 'fs.res.patent.Patent.title',
        inventors: 'fs.res.patent.Patent.inventors',
        registrationDate: 'fs.res.patent.Patent.registrationDate',
        country: 'fs.res.patent.Patent.country',
        grantDate: 'fs.res.patent.Patent.grantDate',
        patentRegistrationTypeValue: 'fs.res.patent.Patent.registrationType'
    };

    getOverSearchResultLink(): SimpleLinkDefinition {
        return null;
    }

    getSubheading(row: HisSearchResultRow, data: any, index: number): string {
        return null;
    }

    getHeaderLine(row: HisSearchResultRow): string {
        const patentType = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['priorityPatent']) === '1' ?
            this.hisUiService.translate('fs.res.patent.Patent.priorityPatent') :
            this.hisUiService.translate('fs.res.patent.Patent.priorityClaim');
        const patentStatus = DetailViewListUtils.capitalizeFirstLetter(DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['status']));
        return patentType + ' | ' + patentStatus;
    }

    getTitleLine(row: HisSearchResultRow): string {
        return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title);
    }

    getToolTip(row: HisSearchResultRow): string {
        return DetailViewListUtils.assembleToolTip(this.getHeaderLine(row).split(' |')[0],
            DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title), this.hisBaseGlobalsService, this.hisUiService);
    }

    getTitleLink(row: HisSearchResultRow): string {
        return '/a/fs.res.frontend/patent/view/' + row.get('Patent.id') +
            '?showBackButton=true&showSearchButton=false';
    }

    getExtendableLine(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        const allInventorNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['inventors']);
        const allInventorNamesSplit = allInventorNames ? allInventorNames.split(', ') : [];
        const firstInventorNames = `${allInventorNamesSplit[0]}, ${allInventorNamesSplit[1]}, ${allInventorNamesSplit[2]} et al.`;
        const textPrefix = this.hisUiService.translate('fs.res.patent.Patent.inventors') + ': ';
        let text;

        if (allInventorNamesSplit.length === 0) {
            text = '';
        } else if (allInventorNamesSplit.length <= 3
            || this.personDetailViewSearchResultComponent.isShowExtendableLine(i, first, rowsPerPage)) {
            text = textPrefix + allInventorNames;
        } else {
            text = textPrefix + firstInventorNames;
        }
        return text;
    }

    getExtendableLineSecond(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        return null;
    }

    isExtendable(row: HisSearchResultRow): boolean {
        const allInventorNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['inventors']);
        const allInventorNamesSplit = allInventorNames ? allInventorNames.split(', ') : [];
        return allInventorNamesSplit.length > 3;
    }

    isExtendableSecond(row: HisSearchResultRow): boolean {
        return false;
    }

    getFooterLine(row: HisSearchResultRow): string {
        const registrationDate = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['registrationDate']);
        const grantDate = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['grantDate']);
        const grantText = this.hisUiService.translate('cs.psv.person.detailview.patents.grantDate.label', grantDate);

        let registrationText;
        if (DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['country']) != null) {
            const country = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['country']);
            registrationText =
                this.hisUiService.translate('cs.psv.person.detailview.patents.registrationDate.label', registrationDate, country);
        } else {
            const type = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['patentRegistrationTypeValue']);
            registrationText =
                this.hisUiService.translate('cs.psv.person.detailview.patents.registrationDate.label2', registrationDate, type);
        }
        return `${registrationText}. ${DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['grantDate']) ? grantText : ''}`;
    }

}
